// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"st-z","giftOrPromoSelector":"tt-z","disabled":"ut-z","subTitle":"vt-z","selectShipAddressMessage":"wt-z","changePayment":"xt-z"};